// import type { AnalysisNg } from "./analysis";
// import type { Bubble } from "./bubble";
// import type { Message } from "./message";

import type { Analysis } from "./analysis";

export type AnalysisGroupInstanceStatus =
  | "created"
  | "started"
  | "fetched"
  | "saved"
  | "finished"
  | "refused";

export interface AnalysisGroupInstance {
  id?: number;
  code?: string;
  name?: string;
  analyses?: Analysis[];
  // bubble?: Bubble;
  // messages?: Message[];
  // externalNote?: string;
  // savedAt?: string;
  // savedBy?: string;
  // readBy?: string;
  // scannedAt?: string;
  selected?: boolean;
  groupnr?: number;
  analysisGroupId: number;
  invoice?: boolean;
  status?: AnalysisGroupInstanceStatus;
}

const defaultAnalysisGroupInstance = {
  selected: true,
};

export function createAnalysisGroupInstance(
  analysisGroupInstance: AnalysisGroupInstance,
) {
  return { ...defaultAnalysisGroupInstance, ...analysisGroupInstance };
}
